import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=0144815e&scoped=true&"
import script from "./transform.vue?vue&type=script&lang=js&"
export * from "./transform.vue?vue&type=script&lang=js&"
import style0 from "./transform.vue?vue&type=style&index=0&id=0144815e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0144815e",
  null
  
)

export default component.exports